import React from "react";
import { useTranslation } from "react-i18next";
import { THEME } from "@/enums/profile";
import { Chart } from "@/services/wingman";
import { GailBarChart } from "@repo/ui/gailgpt/charts";

const AskBarChart: React.FC<{
  chartData: Chart;
  themeOverride?: THEME;
  brandOverride?: string;
}> = ({ chartData }) => {
  const { t } = useTranslation("ask");
  const points = (chartData.data ?? []).flatMap((item) => {
    if (typeof item.label !== "string" || typeof item.value !== "number") return [];
    const group = item.group ? ` (${item.group})` : "";
    return [{ label: `${item.label}${group}`, value: item.value }];
  });
  if (points.length === 0) {
    return <div>{t("chartFailed")}</div>;
  }
  return <GailBarChart title={chartData.title} points={points} />;
};

export default AskBarChart;
